<template>
    <Spinner v-if="newsStore.isLoading" />

    <div id="bst-wrap">
      <div class="l-project-wrap l-project-wrap--mypage">
        <Header v-if="isLoggedIn" />
        <header v-else class="l-header l-header--top">
          <PublicPageHeader />
        </header>
        <section class="l-content-area">
          <div class="l-content">

            <!-- MYPAGE -->
            <section class="p-bloc p-bloc--mypage">
              <div class="p-bloc__content l-wrap__outer">
                <div class="l-wrap__inner">

                  <section class="p-mypage">
                    <NavbarMyPage v-if="isLoggedIn"/>
                    <!-- Side Menu -->
                    <SideMenu v-if="isLoggedIn"/>

                    <!-- Mypage Content -->
                    <div class="p-mypage__content">
                      <div class="mypage-content">

                        <!-- news -->
                        <div class="p-mypage__news mypage-bloc">
                          <div class="mypage-bloc__head">
                            <h2>{{ $t('LABEL_NEWS') }}</h2>
                          </div>
                          <div class="mypage-bloc__content">

                            <!-- news list -->
                            <div class="news__list">
                              <article class="c-news-list" v-for="news in newsStore.newsList">
                                <div class="c-news__head">
                                  <p class="date">{{ news.updated_at }}</p>
                                  <ul class="c-news__label">
                                    <li class="tag"><span>{{ news.category_name }}</span></li>
                                  </ul>
                                </div>
                                <h2>{{ news.title }}</h2>
                                <p v-html="news.content"></p>
                              </article>
                            </div>

                            <!-- PAGING: If there are less than 10 items, hide this area. -->
                          <div class="usage__paging">
                            <Paginator v-model="newsStore.page" :length="newsStore.totalPages"
                              @update:modelValue="searchNews" v-if="newsStore.newsList.length > 0" />
                          </div>

                          </div>
                        </div>

                      </div><!-- .mypage-content -->
                    </div>

                  </section>

                </div>
              </div>
            </section>
          </div><!-- .l-content -->
        </section><!-- .l-content-area -->

      </div><!-- .l-project-wrap -->
      <Footer v-if="isLoggedIn"/>
      <PublicFooter v-else/>
    </div>
</template>

<script setup>
import NavbarMyPage from "@/components/NavbarMyPage.vue";
import Footer from "@/components/Footer.vue";
import SideMenu from "@/components/SideMenu.vue";
import Header from "@/components/Header.vue";
import Paginator from "@/components/Paginator.vue";
import { ref, onBeforeMount } from "vue";
import {useNewsStore} from "@/stores/newsStore";
import Spinner from "@/components/Spinner.vue";
import { useSessionStore } from "@/stores/sessionStore";
import PublicFooter from "@/components/PublicFooter.vue";
import PublicPageHeader from "@/components/PublicPageHeader.vue";

const sessionStore = useSessionStore();
const isLoggedIn = ref(false);

const newsStore = useNewsStore();

onBeforeMount(async () => {
    isLoggedIn.value = sessionStore.isLoggedIn();
    await newsStore.getNews(1);
});

async function searchNews(page) {
    newsStore.page = page;
    await newsStore.getNews(page);
    isLoggedIn.value = sessionStore.isLoggedIn();
}
</script>